module.exports = __webpack_public_path__ + "img/img_demand_02.48479288.jpg";